<div class="flex flex-col gap-5 p-4 pb-[calc(2rem+env(safe-area-inset-bottom))]">
    <!-- Progression 2 étapes (maquette : barre active + label, barre inactive grisée) -->
    <div class="flex flex-col gap-1.5">
        <div class="flex items-center justify-between text-xs font-semibold">
            <span [class]="step === 1 ? 'text-[#317756]' : 'text-[#9BA6A1]'">
                {{ (step === 1 ? 'garden.zone-wizard.progress1' : 'garden.zone-wizard.label1') | translate }}
            </span>
            <span [class]="step === 2 ? 'text-[#317756]' : 'text-[#9BA6A1]'">
                {{ (step === 2 ? 'garden.zone-wizard.progress2' : 'garden.zone-wizard.label2') | translate }}
            </span>
        </div>
        <div class="flex gap-2">
            <span class="h-1 flex-1 rounded-full" [class]="step === 1 ? 'bg-[#317756]' : 'bg-[#317756]/40'"></span>
            <span class="h-1 flex-1 rounded-full" [class]="step === 2 ? 'bg-[#317756]' : 'bg-[#DFE2E1]'"></span>
        </div>
    </div>

    @if (step === 1) {
        <!-- Étape 1 : la zone (réutilise vw-user-adress-location-form) -->
        <div class="flex items-start gap-2 rounded-2xl bg-[#DAF2E0] p-3 text-sm text-[#062825]">
            <span>📍</span>
            <p>{{ 'garden.zone-wizard.zone-intro' | translate }}</p>
        </div>
        <vw-user-adress-location-form [location]="null" (closeLocationForm)="onZoneCreated($event)"></vw-user-adress-location-form>
    } @else {
        @if (!showAddBedSheet) {
            <!-- Étape 2 : les planches -->
            <div class="flex flex-col gap-4">
                <h2 class="text-[#062825] text-xl font-semibold">
                    {{ 'garden.zone-wizard.created-title' | translate: { name: $safeNavigationMigration(createdLocation?.name) } }}
                </h2>
                <div class="flex items-start gap-2 rounded-2xl bg-[#DAF2E0] p-3 text-sm text-[#062825]">
                    <span>🪴</span>
                    <p>{{ 'garden.zone-wizard.beds-intro' | translate }}</p>
                </div>

                <div class="flex flex-col gap-2">
                    @for (bed of addedBeds; track $index) {
                        <div class="flex items-center gap-3 rounded-2xl border border-[#DFE2E1] bg-white p-3">
                            <span class="text-xl">{{ bed.type === 'POT' ? '🪴' : '🔲' }}</span>
                            <div class="min-w-0 flex-1">
                                <p class="truncate text-sm font-semibold text-[#062825]">{{ bed.name }}</p>
                                <p class="text-xs text-[#9BA6A1]">
                                    @if (bed.type === 'POT') {
                                        {{ bed.capacity }} {{ 'garden.zone-wizard.pot-capacity' | translate }}
                                    } @else {
                                        {{ bed.rows }} × {{ bed.columns }}
                                    }
                                </p>
                            </div>
                            <button type="button" (click)="removeBed($index)" [disabled]="deletingBedIndex !== null"
                                class="px-2 text-lg text-[#C5132E] active:opacity-60 disabled:opacity-40"
                                [attr.aria-label]="'garden.zone-wizard.delete-bed' | translate">
                                @if (deletingBedIndex === $index) { ⏳ } @else { 🗑 }
                            </button>
                        </div>
                    } @empty {
                        <p class="rounded-2xl bg-gray-50 p-4 text-center text-sm text-[#9BA6A1]">{{ 'garden.zone-wizard.empty' | translate }}</p>
                    }
                </div>

                <button type="button" (click)="openAddBed()"
                    class="w-full rounded-full border-[1.5px] border-dashed border-[#317756] py-3 text-sm font-semibold text-[#317756]">
                    + {{ 'garden.zone-wizard.add-bed' | translate }}
                </button>

                <button type="button" (click)="finish()"
                    class="w-full rounded-full bg-primary py-3 text-sm font-semibold text-white hover:bg-black transition">
                    {{ 'garden.zone-wizard.finish' | translate }}
                </button>
                <button type="button" (click)="finish()" class="text-center text-sm text-[#9BA6A1] underline">
                    {{ 'garden.zone-wizard.later' | translate }}
                </button>
            </div>
        } @else {
            <!-- Sous-feuille : ajouter une planche (réutilise vw-garden-bed-create inline) -->
            <button type="button" (click)="closeAddBed()" class="flex items-center gap-1 text-sm font-medium text-[#317756]">
                ← {{ 'garden.zone-wizard.back-to-beds' | translate }}
            </button>
            <vw-garden-bed-create [locationUid]="createdLocation.uid" [autoNavigate]="false"
                (bedCreated)="onBedCreated($event)"></vw-garden-bed-create>
        }
    }
</div>
